import {
  ColorsPrimary500,
  ColorsPrimary900,
  ColorsSuccess500,
  ColorsSuccess900,
} from '@efexteam/design-tokens';
import CheckIcon from '@mui/icons-material/Check';
import SdCardAlertIcon from '@mui/icons-material/SdCardAlert';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import { AlertConfigMap } from './types';

export const ALERT_CONFIGS: AlertConfigMap = {
  approve: {
    icon: CheckIcon,
    titleKey: 'apprBnfTitle',
    subtitleKey: 'apprBnfSubtitle',
    iconColor: ColorsSuccess900,
    backgroundColor: ColorsSuccess500,
  },
  decline: {
    icon: SdCardAlertIcon,
    titleKey: 'rjctBnfTitle',
    subtitleKey: 'rjctBnfSubtitle',
    iconColor: ColorsPrimary900,
    backgroundColor: `${ColorsPrimary900}1A`,
  },
  expire: {
    icon: SentimentVeryDissatisfiedIcon,
    titleKey: 'xprBnfTitle',
    subtitleKey: 'xprBnfSubtitle',
    iconColor: ColorsPrimary900,
    backgroundColor: `${ColorsPrimary900}1A`,
  },
  pending: {
    icon: TimerOutlinedIcon,
    titleKey: 'pendingBnfTitle',
    subtitleKey: 'pendingBnfSubtitle',
    iconColor: ColorsPrimary500,
    backgroundColor: `${ColorsPrimary500}1A`,
  },
};

export const DEFAULT_PROMOTER_NAME = '';
